
/*
 *   File : kyc-submission.js
 *   Author URI : https://evoqins.com
 *   Description : KYC Submission success pop up
 *   Integrations : null
 *   Version : v1.1
 */


import { useEffect, useState } from "react";
import style from "../../Styles/Components/delete.module.scss"
import { GradientButton } from "../Cta";
import { Icon } from "../Icon";
import { CustomToolTip } from "../Popups";
import { toast } from "react-toastify";
import APIService from "../../Services/api-service";

const UpdateNominee = (props) => {
    const [shareUrl, setShareUrl] = useState('');
    const [showToolTip, setShowToolTip] = useState(false);

  useEffect(() => {
        var my_modal = document.getElementById("update-nomiee");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
        });
    }, [props.close]);

    useEffect(() => {
        _getLink();
    }, []);


    function _getLink(id) {
        let url = 'user/initiate-profile-update';
        let payload = JSON.stringify({
            customer_id: props.data.id,
            type: 1
        });
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                setShareUrl(response.data);
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: 'error'
                })
            }

        })
    }



    function _copyLink() {
        const linkText = document.getElementById('e-copy-link').innerText;
        const tempInput = document.createElement('input');
        tempInput.setAttribute('value', linkText);
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);
        navigator.clipboard.writeText(shareUrl);

        setShowToolTip(true);
        setTimeout(() => {
            setShowToolTip(false);
        }, 2000);
    }


    return (
        <div className={`modal fade ${style.e_approve_kyc}`}
            id="update-nomiee"
            tabIndex="-1"
            aria-labelledby="update-nomiee"
            aria-hidden="true"
            data-bs-backdrop="static" >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>

                <div className={`modal-content bg-modal padding-32px-lr py-4 mb-5 ${style.e_content} `}>
                    <div className="row">
                        <div className="col-12 d-flex justify-content-between">
                            <h3 className="color-black e-poppins-semi-bold e-font-18">
                                Update nominee details
                            </h3>
                            <Icon icon="close"
                                size={24}
                                className="cursor-pointer ms-auto e-modal-close-btn"
                                data-bs-dismiss="modal" />
                        </div>
                    </div>
                    <div className="d-flex gap-2 align-items-start border-radius-8px bg-beige w-fit-content p-2 my-4">
                        <span>
                            <Icon icon="info"
                                size={24} />
                        </span>
                        <p className="color-outer-space e-poppins-regular e-font-14 line-height-26px mb-0">
                            To comply with SEBI's latest guidelines and continue making investments without interruption, User must update its nominee details now. This includes submitting identity proof (PAN, Aadhaar, Driving License, or Passport), contact information, and complete address. For minor nominees, user will need to provide the guardian's details in the same way. Please ensure all information matches user's official documents exactly.                        </p>
                    </div>
                    <div className="position-relative bg-white w-100 ">
                        <div className={`w-100 d-flex justify-content-between border-all border-bright-gray border-radius-8px p-3 `}
                        // style={{ marginTop: cardId === 1 ? '0px' : cardId === 2 ? '110px' : cardId === 3 ? '210px' : '308px' }}
                        >
                            <div className=" col-8">
                                <div className="d-flex">
                                    <Icon icon="copy"
                                        size={16}
                                        className='mt-1 me-2' />
                                    <p className="color-primary-color e-font-14 e-poppins-regular mb-0"
                                        id="e-copy-link">{shareUrl}</p>
                                </div>
                            </div>
                            <div className="col-4 text-end">

                                <span className="color-light-black e-poppins-regular e-font-14 position-relative cursor-pointer animated-underline white-space-nowrap"
                                    onClick={_copyLink}>
                                    Copy link
                                    {showToolTip === true && (
                                        <CustomToolTip content="Link copied!" />
                                    )}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
};

export default UpdateNominee